import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import { Color } from "../../../Utils/styles";
import { FaPhone } from "react-icons/fa";
import { BiSupport } from "react-icons/bi";
import { AiFillCaretLeft } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useSupport } from "./hook";
import { Spinner } from "react-bootstrap";
//
const Support = () => {
  const { popUp, dispatch, close, form, setForm, store, loading, user } =
    useSupport();

  const renderComponent = () => {
    switch (form.step) {
      case 1:
        return (
          <>
            <div className="support-head">
              <h2>پشتیبانی آنلاین نیکوتن </h2>
              <CloseIcon onClick={close} />
            </div>
            <div className="support-content">
              <p>برای رزرو مجموعه ها با مشکل مواجه شدی 🤔؟‌</p>
              <p>نگران نباش ☺️!</p>
              <p>با پشتیبانی تماس بگیر ، کاملا راهنماییت میکنیم😎💪.</p>
              <p>
                حتی میتونی شماره همراهتو برامون بفرستی تا خودمون باهات تماس
                بگیریم 😁🤙.
              </p>
            </div>
            <div className="support-action">
              <button>
                <span>
                  <FaPhone
                    className="support-action-icon"
                    color={Color.primary}
                  />
                </span>

                <a
                  className="btn-text"
                  style={{ cursor: "pointer" }}
                  href="tel:02191027127"
                  onClick={() => close(true)}
                >
                  تماس با پشتیبانی
                </a>
              </button>
              <button
                onClick={() => {
                  setForm({ ...form, step: 2 });
                }}
              >
                <span>
                  <BiSupport
                    className="support-action-icon"
                    size={"1.2rem"}
                    color={Color.primary}
                  />
                </span>
                <span className="btn-text">درخواست پشتیبانی</span>
              </button>
            </div>
            <div className="support-faq">
              <span
                onClick={() => {
                  // navigate("/faq");
                }}
                className="faq-btn"
              >
                سوالات متداول
              </span>
              <span style={{}} className="faq-icon">
                <AiFillCaretLeft />
              </span>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className="support-head">
              <h2>درخواست پشتیبانی</h2>
              <CloseIcon onClick={() => close(false)} />
            </div>
            <div className="form-support">
              <div className="auth-form-support">
                <div style={{ flex: 1 }} className="mt-1">
                  <label
                    htmlFor="name"
                    className="mb-1"
                    style={{
                      fontWeight: "400",
                    }}
                  >
                    نام و نام خانوادگی
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="w-100 form-control"
                    onChange={({ target: { value } }) => {
                      setForm({ ...form, fullname: value });
                    }}
                    defaultValue={user?.fullname}
                    // value={user && user.fullname}
                    // style={{
                    //   border: isIn("fullname")
                    //     ? "1px solid red"
                    //     : "1px solid #ced4da",
                    // }}
                  />
                </div>
                <div className="mx-2"></div>
                <div style={{ flex: 1 }} className="mt-1">
                  <label
                    htmlFor="mobile"
                    className="mb-1"
                    style={{
                      fontWeight: "400",
                    }}
                  >
                    {" "}
                    شماره همراه
                  </label>
                  <input
                    type="number"
                    id="mobile"
                    className="w-100 form-control"
                    onChange={({ target: { value } }) => {
                      setForm({ ...form, mobile: value });
                    }}
                    defaultValue={user?.mobile}

                    // value={user && user.mobile}
                    // style={{
                    //   border: isIn("mobile")
                    //     ? "1px solid red"
                    //     : "1px solid #ced4da",
                    // }}
                  />
                </div>
              </div>

              <div className="btn-form-support mt-3">
                <button
                  onClick={store}
                  className="btn  w-100 "
                  style={{ color: Color.white, cursor: "pointer" }}
                >
                  {loading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: Color.black }}
                    />
                  ) : (
                    "ارسال به پشتیبانی"
                  )}
                </button>
              </div>
            </div>
          </>
        );
      default:
        break;
    }
  };
  return (
    <Dialog //
      style={{}}
      scroll="paper"
      open={popUp && popUp.status}
      // open={true}
      onClose={() => close(false)}

      //
    >
      <div id="support-component">{renderComponent()}</div>
    </Dialog>
  );
};

export default Support;
